import { gql } from "@apollo/client";

export const GET_DEVICES = gql`
  query GetAllDevices {
    allMdmDevices {
      id
      identifier
      tags
      objectRelation {
        mdmObject {
          id
          title
        }
      }
    }
  }
`;

export const GET_DEVICES_BY_PROJECT = gql`
  query GetAllDevicesByProject($id: String!) {
    mdmDeviceByProjectId(projectId: $id) {
      id
      identifier
      tags
      config {
        vitalityThreshold
      }
      boundDatasets {
        all {
          identifier
        }
			}
      objectRelation {
        mdmObject {
          id
          title
        }
      }
    }
  }
`;

export const GET_DEVICE = gql`
  query GetDevice($id: String!) {
    mdmDeviceById(id: $id) {
      id
      identifier
      tags
      boundDatasets {
        all {
          identifier
          title
        }
        mapped {
          dataset {
            identifier
            title
          }
          mapping
        }
      }
      customFields {
        key
        value {
          type
          value
        }
      }
      createdAt
      modifiedAt
      config {
        id
        title
        projectId
        vitalityThreshold
        measurementMappings {
          key
          value
        }
      }
      objectRelation {
        mdmObject {
          id
          title
        }
      }
    }
  }
`;

export const CREATE_DEVICE = gql`
  mutation CreateDevice($device: MdmDeviceDTOInput!, $objectId: String!) {
    createMdmDevice(input: $device, objectId: $objectId) {
      id
      identifier
      tags
      objectRelation {
        mdmObject {
          id
          title
        }
      }
      config {
        id
        vitalityThreshold
      }
      boundDatasets {
        all {
          identifier
        }
      }
      modifiedAt
      createdAt
    }
  }
`;

export const UPDATE_DEVICE = gql`
  mutation UpdateDevice($device: MdmDeviceDTOInput!, $objectId: String!) {
    updateMdmDevice(input: $device, objectId: $objectId) {
      id
      identifier
      tags
      objectRelation {
        mdmObject {
          id
        }
      }
      config {
        id
      }
    }
  }
`;

export const DELETE_DEVICE = gql`
  mutation DeleteDevice($id: String!) {
    deleteMdmDevice(id: $id) {
      id
      config {
        id
      }
      boundDatasets {
        all {
          identifier
        }
      }
      modifiedAt
      createdAt
    }
  }
`;
